"use client";

import type { ReactNode } from "react";
import { SpaceMenuBackground } from "../SpaceMenuBackground";
import { ActivityHeader } from "./ActivityHeader";
import { ActivityRocketBuddy } from "./ActivityRocketBuddy";

interface ActivityLayoutProps {
  title: string;
  headerExtra?: ReactNode;
  headerActions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Show the player's rocket in the corner during play. */
  showRocketBuddy?: boolean;
}

/** Full-viewport activity shell — no page scroll, Pixi/game area grows to fill space. */
export function ActivityLayout({
  title,
  headerExtra,
  headerActions,
  children,
  className = "",
  showRocketBuddy = true,
}: ActivityLayoutProps) {
  return (
    <div className={`relative flex h-dvh min-h-0 w-full flex-col overflow-hidden ${className}`}>
      <SpaceMenuBackground variant="activity" />
      <div className="relative z-10 flex min-h-0 flex-1 flex-col overflow-hidden">
        <div className="shrink-0 border-b border-white/10 bg-slate-950/75 px-3 py-2 shadow-sm backdrop-blur-md">
          <ActivityHeader title={title} actions={headerActions}>
            {headerExtra}
          </ActivityHeader>
        </div>
        <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
          {children}
          {showRocketBuddy && <ActivityRocketBuddy />}
        </div>
      </div>
    </div>
  );
}
